import { ELocalStorageKey } from '@enums';

import { Log } from './Log';

export const getFromLocalStorage = (key: ELocalStorageKey | string): string => {
	try {
		return window?.localStorage.getItem(key);
	} catch (err) {
		Log.error(`Failed read key ${key} from localStorage: ${err && err.toString() ? err.toString() : String(err)}`);
	}
};

export const setToLocalStorage = (key: ELocalStorageKey | string, value: string): void => {
	try {
		window?.localStorage.setItem(key, value);
	} catch (err) {
		Log.error(`Failed write key ${key} to localStorage: ${err && err.toString() ? err.toString() : String(err)}`);
	}
};

export const removeFromLocalStorage = (key: ELocalStorageKey | string): void => {
	try {
		window?.localStorage.removeItem(key);
	} catch (err) {
		Log.error(`Failed remove key ${key} from localStorage: ${err && err.toString() ? err.toString() : String(err)}`);
	}
};
